"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var reactstrap_1 = require("reactstrap");
var NoResultsMessage_1 = __importDefault(require("./NoResultsMessage"));
var noResultsMsg = 'No results found.';
var BasicListResults = function (_a) {
    var onClickRow = _a.onClickRow, selectedObject = _a.selectedObject, className = _a.className, items = _a.items, fromItemProps = _a.fromItemProps, ComponentToRender = _a.component, _b = _a.rowProps, rowProps = _b === void 0 ? {} : _b;
    if (!items) {
        return (0, jsx_runtime_1.jsx)(reactstrap_1.Col, { className: "ds-list__results" });
    }
    var content = !items.length
        ? (0, jsx_runtime_1.jsx)(NoResultsMessage_1.default, { text: noResultsMsg })
        : items.map(function (item) { return ((0, jsx_runtime_1.jsx)(ComponentToRender, __assign({ item: item, isActive: selectedObject && selectedObject.id === item.id, isHalf: !!selectedObject, onClickRow: onClickRow }, rowProps, fromItemProps === null || fromItemProps === void 0 ? void 0 : fromItemProps(item)), "item-".concat(item.id))); });
    return ((0, jsx_runtime_1.jsxs)(reactstrap_1.Col, __assign({ className: (0, classnames_1.default)(className, 'ds-list__results-col') }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "ds-list__results-border-top" }), content] })));
};
exports.default = BasicListResults;
